<template>
  <b-button variant="primary" @click="$emit('click', $event)" :disabled="disabled">
    <slot />
  </b-button>
</template>

<script>
  export default {
    name: "AddNewButton",
    data() {
      return {};
    },
    computed: {},
    methods: {},
    props: {
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
